import React, { Component } from "react";
import { Row, Col, Container, Table } from "react-bootstrap";
import "react-day-picker/lib/style.css";
import axiosInstance from "../../api/utils/axiosInstance";
import OsobeSearch from "../../components/PregledSearch/OsobeSearch";
import Badge from "react-bootstrap/Badge";
import Spinner from "react-bootstrap/Spinner";
import "../../components/StrucnaUsavrsavanja/StrucnaUsavrsavanja.css";
import {
  formSubmitSuccess,
  formSubmitError,
} from "../../store/actions/forms/formActions";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { FormOutlined } from "@ant-design/icons";
import ButtonComponent from "../../components/UI/ButtonComponent/ButtonComponent";
import { Pagination } from "antd";
import { SSUMenu } from "./SSUMenu";

class StrucnaUsavrsavanja extends Component {
  state = {
    data: [],
    totalPageCount: 0,
    registriSearchModel: {
      formId: null,
      pojam: "",
      nazSubjekta: null,
      oib: null,
      regBroj: null,
      ime: null,
      prezime: null,
      drzava: null,
      pageNumber: 1,
      offset: 10,
    },
    isListLoading: true,
    isLoading: false,
    pregledModal: false,
    noDataMessage: "",
  };

  componentDidMount() {
    this.getRevizori();
  }

  getRevizori() {
    this.setState(
      {
        registriSearchModel: {
          ...this.state.registriSearchModel,
        },
      },
      () => {
        axiosInstance
          .post(
            "/strucno-usavrsavanje/revizori",
            this.state.registriSearchModel
          )
          .then((res) => {
            this.setState(
              {
                data: res.data.result,
                totalPageCount: res.data.size,
                isListLoading: false,
              },
              () => {
                if (this.state.data.length < 1) {
                  this.setState({
                    noDataMessage:
                      "Nema unesenih podataka o evidenciji stalnog stručnog usavršavanja.",
                  });
                }
              }
            );
          });
      }
    );
  }

  onOsobeSearchChanged = (e) => {
    let pojam = String(e.target.value).trim().toLowerCase();

    this.setState({
      registriSearchModel: {
        ...this.state.registriSearchModel,
        pojam: pojam,
        prezime: pojam,
        ime: pojam,
        regBroj: pojam,
      },
    });
  };

  onSearchSubmitted = (e) => {
    this.setState({
      noDataMessage: "",
    });
    if (
      this.state.registriSearchModel.pojam.length == 0 ||
      this.state.registriSearchModel.pojam.length >= 3
    ) {
      this.setState({ isListLoading: true });
      axiosInstance
        .post("/strucno-usavrsavanje/revizori", this.state.registriSearchModel)
        .then((res) => {
          this.setState(
            {
              registriSearchModel: {
                ...this.state.registriSearchModel,
                pageNumber: 1,
                offset: 10,
              },
              data: res.data.result,
              totalPageCount: res.data.size,
              isListLoading: false,
            },
            () => {
              if (this.state.data.length < 1) {
                this.setState({
                  noDataMessage: "Zadana pretraga nema rezultata.",
                });
                this.props.formSubmitError(
                  true,
                  "Subjekt nije upisan u registar. Molimo provjerite upisane podatke za pretragu."
                );
              }
            }
          );
        });
    } else {
      toast.info("Morate unijeti minimalno 3 znaka.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  pageChanged = (pageNumber, pageSize) => {
    this.setState(
      {
        isLoading: true,
        registriSearchModel: {
          ...this.state.registriSearchModel,
          pageNumber: pageNumber,
        },
      },
      () => {
        axiosInstance
          .post(
            "/strucno-usavrsavanje/revizori",
            this.state.registriSearchModel
          )
          .then((res) => {
            this.setState({
              data: res.data.result,
              isLoading: false,
            });
          });
      }
    );
  };

  getOsobaDrustvo(element) {
    let drustva;

    if (element.osobaDrustvo.length > 0) {
      drustva = element.osobaDrustvo.map((drustvo, index) => {
        let zarez = element.osobaDrustvo.length - 1 != index ? " ," : "";

        return (
          <Row key={`drustvo-key${index}`}>
            {drustvo.nazivDrustva
              ? drustvo.nazivDrustva
              : drustvo.imeDrustva + " " + drustvo.prezimeDrustva}
            {zarez}
          </Row>
        );
      });
    } else {
      return <i>Nema povezanog revizorskog društva.</i>;
    }
    return (
      <Container>
        <Row>
          <Col>{drustva}</Col>
        </Row>
      </Container>
    );
  }

  onEnterPressed = (e) => {
    if (e.charCode == 13) {
      this.onSearchSubmitted();
    }
  };

  render() {
    let items = [];
    const isRoleAdmin = this.props.userRole === "ROLE_REFERENT" || this.props.userRole === "ROLE_SLUZBENIK";

    let pageCount = Math.ceil(
      this.state.totalPageCount / this.state.registriSearchModel.offset
    );

    if (pageCount <= 10) {
      for (let page = 1; page <= pageCount; page++) {
        items.push(
          <Pagination
            key={page}
            active={page === this.state.registriSearchModel.pageNumber}
            onClick={(e) => this.pageChanged(page)}
          >
            {page}
          </Pagination>
        );
      }
    } else {
      for (let page = 1; page <= 10; page++) {
        items.push(
          <Pagination
            key={page}
            active={page === this.state.registriSearchModel.pageNumber}
            onClick={(e) => this.pageChanged(page)}
          >
            {page}
          </Pagination>
        );
      }

      //Commented out because it throws error
      //items.push(<Pagination.Ellipsis />);
      items.push(
        <Pagination
          key={this.state.totalPageCount}
          active={this.state.registriSearchModel.pageNumber === pageCount}
          onClick={(e) => this.pageChanged(pageCount)}
        >
          {pageCount}
        </Pagination>
      );
    }

    return (
      <>
        <div>
          <Row className="row justify-content-center" key={"form"}>
            <Col lg={12} className="align-self-center">
              <OsobeSearch
                onSearchChanged={(e) => this.onOsobeSearchChanged(e)}
                onSearchSubmitted={(e) => this.onSearchSubmitted}
                onEnterPressed={(e) => this.onEnterPressed(e)}
              />
            </Col>
          </Row>
          <br />
          <br />
          {this.state.isListLoading ? (
            <Container className="dataLoader">
              <Row style={{ justifyContent: "center" }}>
                <Col style={{ alignItems: "center" }}>
                  <Spinner
                    animation="border"
                    variant="secondary"
                    style={{ marginTop: "16px", marginBottom: "16px" }}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <div style={{ marginTop: "16px", marginLeft: "16px" }} className="spin-text">
                    <b>Učitavam...</b>
                  </div>
                </Col>
              </Row>
            </Container>
          ) : null}

          <SSUMenu/>
          
          {this.state.data.length > 0 ? (
            <div className="mb-3 strucna-usavrsavanja">
              <br></br>
              <Table bordered hover responsive>
                <thead>
                  <tr className="tr_table">
                    <th scope="col">Ime i prezime</th>
                    {isRoleAdmin && <th scope="col">Status</th>} 
                    <th scope="col">OIB / Identifikacijski broj</th>
                    <th scope="col">Registarski broj</th>
                    <th scope="col">Revizorsko društvo</th>
                    <th scope="col">Vrsta registra</th>
                    <th scope="col">Adresa</th>
                    <th scope="col">Akcija</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.data.map((element) => (
                    <tr key={element.osoba.idOsobe}>
                      <td>
                        {element.osoba.ime} {element.osoba.prezime}
                      </td>
                      {isRoleAdmin && 
                        <td>
                          {element.osoba.oznAkt == 1 ? (
                            <Badge pill variant="success">
                              Aktivan
                            </Badge>
                          ) : (
                            <Badge pill variant="danger">
                              Brisan
                            </Badge>
                          )}
                        </td>
                      }
                      <td>
                        {element.osoba.oib
                          ? element.osoba.oib
                          : element.osoba.idBroj}
                      </td>
                      <td>{element.osoba.regBroj}</td>
                      <td>{this.getOsobaDrustvo(element)}</td>
                      <td>
                        {element.osoba.vrOsobe === 3
                          ? "Revizor iz druge zemlje"
                          : element.osoba.vrOsobe === 4
                          ? "Revizor iz treće zemlje"
                          : element.osoba.vrOsobe === 5
                          ? "Revizor u trećoj zemlji"
                          : "Ovlašteni revizor"}
                      </td>
                      <td>
                        {element.adresaOsobe.ulicaKbr &&
                          element.adresaOsobe.ulicaKbr + ","}{" "}
                        {element.adresaOsobe.nazNaselja &&
                          element.adresaOsobe.nazNaselja + ","}{" "}
                        {element.adresaOsobe.drzava}
                      </td>
                      <td className="ant_batn">
                        <Link
                          to={{
                            pathname: `/pregled-strucnih-usavrsavanja/${element.osoba.idOsobe}`,
                          }}
                        >
                          <ButtonComponent variant="secondary">
                            <FormOutlined />
                          </ButtonComponent>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <div style={{ textAlign: "center", marginTop: "0px" }}>
              <p className="search-result-text">{this.state.noDataMessage}</p>
            </div>
          )}
        </div>

        <div>
          {this.state.isLoading ? (
            <Container style={{ display: "flex", justifyContent: "center" }}>
              <Row style={{ justifyContent: "center" }}>
                <Col style={{ alignItems: "center" }}>
                  <Spinner
                    animation="border"
                    variant="secondary"
                    style={{ marginTop: "16px", marginBottom: "16px" }}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <div style={{ marginTop: "16px", marginLeft: "16px" }} className="spin-text">
                    <b>Učitavam...</b>
                  </div>
                </Col>
              </Row>
            </Container>
          ) : null}
          {this.state.totalPageCount > 0 ? (
            <div
              style={{
                width: "100%",
                justifyContent: "center",
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <Pagination
                defaultCurrent={1}
                defaultPageSize={10}
                total={this.state.totalPageCount}
                responsive
                onChange={this.pageChanged}
                showSizeChanger={false}
              />
            </div>
          ) : null}
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    formSubmitError: (error, notificationMessage) =>
      dispatch(formSubmitError(error, notificationMessage)),
    formSubmitSuccess: (error, notificationMessage) =>
      dispatch(formSubmitSuccess(error, notificationMessage)),
  };
};

const mapStateToProps = (state) => {
  return {
    userRole: state.authentication.userData
    ? state.authentication.userData.roles[0].roleName
    : "",
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StrucnaUsavrsavanja);
